export default __webpack_public_path__ + "static/media/03.a8c17af3.jpg";